export default {

    init() {
        const MOBILE_VIEWPORT_WIDTH = 768;

        // lets not run this on the insight page 
        // so that it does not interfer with the other filter logic
        if($('body.insight-landing-page').length){
            return;
        }

        // will need to be added multiple times
        // once when the page loads and again when more items are loaded
        function loadMoreListener() {
            $('#load-more').on('click', function (e) {
                e.preventDefault();
                // make sure to remember that this is a new search
                newSearch = false;
                // remove parent container with margin-top
                $(this).parent().remove();
                querySearch(params);
            });
        }

        // more specific filter handler for the search page
        // allows users to x off and remove active filters
        function activeFiltersListener() {
            $('[data-js="remove"]').on('click', function (e) {
                e.preventDefault();

                let $elem = $(this);
                let $form = $($elem.attr('data-form'));
                let target = $elem.attr('data-target');

                newSearch = true;
                // reset the category filter in the sidebar
                $('.search__filter--option').filter(function () {
                    return $(this).data('slug') === $elem.attr('data-value');
                }).removeClass('active');
                // remove the hidden input from the search form
                $form.find(`[name=${target}]`)[0].value = '';
                // this will trigger the ajax call to refresh the list
                $form.trigger('submit');
            });
        }
        // make sure this is run on the first load as well as each ajax query
        activeFiltersListener();

        let newSearch = false;
        let params = new URLSearchParams(window.location.search);
        if ($('#load-more').length > 0) {
            params = new URLSearchParams($('#load-more').data('query').trim());
            console.log(params);
            loadMoreListener();
        }

        function querySearch(params) {
            // strange bug on the staging site where this param is being added
            // we will force remove it here so there is no issue
            params.delete('p');

            $.ajax({
                url: `${window.location.origin}/search/pagination?${params.toString()}`,
                method: 'POST',
                success: (data) => {
                    // console.log(data);

                    // determine if the items should be appended or replaced
                    if (newSearch) {
                        $('#search-results').html(data);

                        // if this is a new search go to the top of the results
                        $('html,body').animate({ scrollTop: $('#result-counter').offset().top }, 400);
                    } else {
                        $('#search-results').append(data);
                    }

                    // update the active filters and results counter
                    // which are at the end of the search results template
                    let $activeFilters = $('#search-results').find('.filter-set__active-filters');
                    let $resultsCounter = $('#search-results').find('.result-counter');
                    $('#active-filters').html($activeFilters);
                    $('#result-counter').html($resultsCounter);

                    // add the listener for the active filters
                    activeFiltersListener();

                    // update the url of the page
                    window.history.pushState({}, '', `/search?${params.toString()}`);

                    // update the parameters for the next query
                    // @TODO there is probably a bug here
                    const currentPage = parseInt(params.get('page'));
                    const page = isNaN(currentPage) || currentPage < 1 ? 1 : currentPage;
                    const newPage = page + 1;
                    params.set('page', newPage);


                    // update the load more button
                    if ($('#load-more').length > 0) {
                        // if there are no more pages, hide the load more button
                        if (newPage > $('#load-more').data('total-pages')) {
                            $('#load-more').hide();
                        } else {
                            $('#load-more').show();
                            $('#load-more').attr('href', `/search?${params.toString()}`);
                        }
                        loadMoreListener()
                    }
                }
            });
        }

        // Go to another category, a click on a filter
        $('.search__filter--option').on('click', function (e) {
            e.preventDefault();
            let $link = $(this);
            let key = $link.data('key');
            let slug = $link.data('slug');
            let isActive = $link.hasClass('active');

            // this will remember which option was clicked last
            // that will be the displayed CTA banner for the search
            params.set('featured', key);

            // update the params for the next query
            newSearch = true;
            params.set('page', 1);

            // Remove active class from all options in the same group
            $link.parent().find('.search__filter--option').removeClass('active');

            // colapse the parent category group after a selection
            // $link.parent().parent().find('.search__filter--header').trigger('click');
            // colapse all categories after a selection
            $('.search__filter--options').slideUp();
            
            if (isActive) {
                params.delete(key);
                $('#search-form').find(`[name=${key}]`)[0].value = '';
            } else {
                params.set(key, $link.data('slug'));
                console.log($('#search-form'));
                // update the input value in the search form (for when a new keyword is selected)
                $('#search-form').find(`[name=${key}]`)[0].value = slug;
                $link.addClass('active');
            }

            querySearch(params);
        });


        // handle submit of keyword search input field form
        $('#search-form').on('submit', function (e) {
            e.preventDefault();
            newSearch = true;
            // hide the filter options when a new search is made
            $('.search__filter--options').slideUp();
            params = new URLSearchParams($(this).serialize());
            querySearch(params);
        });

        // switches the placeholder text of the search input field to a mobile friendly version
        function checkMobile() {
            if (window.innerWidth < MOBILE_VIEWPORT_WIDTH) {
                $('#search-1').attr('placeholder', 'Search for Our Services, Reports…');
            } else {
                $('#search-1').attr('placeholder', 'Search for Our Services, Market Insights, Reports and More…');
            }
        }
        if ($('#search-1').length > 0) {
            checkMobile();
            $(window).on('resize', checkMobile);
        }

        // opens and closes the categories for the filters in the sidebar
        $('.search__filter').each(function () {
            const $this = $(this);
            const $header = $this.find('.search__filter--header');
            const $options = $this.find('.search__filter--options');
            $header.on('click', function () {
                $options.slideToggle();
            });
        });
    },
};
